const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';

export const getGPT3Response = async (inputText, conversationHistory) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/chat`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ inputText, conversationHistory }),
    });

    if (!response.ok) {
      throw new Error(`Backend responded with ${response.status}`);
    }

    const data = await response.json();
    return data.reply;
  } catch (error) {
    console.error('Chat API error:', error.message);
    return 'An error occurred while processing your request.';
  }
};
